import { useEffect, useState } from "react";

import {
  DEFAULT_CONTRIBUTION_SETTINGS,
  DEFAULT_EID_SETTINGS,
  DEFAULT_HIJRI_SETTINGS,
  DEFAULT_JUMMAH_SETTINGS,
  DEFAULT_MOSQUE_PROFILE,
  DEFAULT_PRAYER_SETTINGS,
  DEFAULT_RAMADAN_SETTINGS,
  watchContributionSettings,
  watchEidSettings,
  watchHijriSettings,
  watchJummahSettings,
  watchMosqueProfile,
  watchPrayerSettings,
  watchRamadanSettings,
} from "@/data/settings.repo";
import type {
  ContributionSettings,
  EidSettings,
  HijriSettings,
  JummahSettings,
  MosqueProfile,
  PrayerSettings,
  RamadanSettings,
} from "@/data/types";
import { readCache, writeCache } from "@/lib/cache";

const KEY = {
  prayer: "jmd:settings:prayer",
  hijri: "jmd:settings:hijri",
  mosque: "jmd:settings:mosque",
  contribution: "jmd:settings:contribution",
  jummah: "jmd:settings:jummah",
  eid: "jmd:settings:eid",
  ramadan: "jmd:settings:ramadan",
};

export function usePrayerSettings(): PrayerSettings {
  const [data, setData] = useState<PrayerSettings>(() =>
    readCache(KEY.prayer, DEFAULT_PRAYER_SETTINGS),
  );
  useEffect(() => {
    return watchPrayerSettings((v) => {
      setData(v);
      writeCache(KEY.prayer, v);
    });
  }, []);
  return data;
}

export function useHijriSettings(): HijriSettings {
  const [data, setData] = useState<HijriSettings>(() =>
    readCache(KEY.hijri, DEFAULT_HIJRI_SETTINGS),
  );
  useEffect(() => {
    return watchHijriSettings((v) => {
      setData(v);
      writeCache(KEY.hijri, v);
    });
  }, []);
  return data;
}

export function useMosqueProfile(): MosqueProfile {
  const [data, setData] = useState<MosqueProfile>(() =>
    readCache(KEY.mosque, DEFAULT_MOSQUE_PROFILE),
  );
  useEffect(() => {
    return watchMosqueProfile((v) => {
      setData(v);
      writeCache(KEY.mosque, v);
    });
  }, []);
  return data;
}

export function useContributionSettings(): ContributionSettings {
  const [data, setData] = useState<ContributionSettings>(() =>
    readCache(KEY.contribution, DEFAULT_CONTRIBUTION_SETTINGS),
  );
  useEffect(() => {
    return watchContributionSettings((v) => {
      setData(v);
      writeCache(KEY.contribution, v);
    });
  }, []);
  return data;
}

export function useJummahSettings(): JummahSettings {
  const [data, setData] = useState<JummahSettings>(() =>
    readCache(KEY.jummah, DEFAULT_JUMMAH_SETTINGS),
  );
  useEffect(() => {
    return watchJummahSettings((v) => {
      setData(v);
      writeCache(KEY.jummah, v);
    });
  }, []);
  return data;
}

export function useEidSettings(): EidSettings {
  const [data, setData] = useState<EidSettings>(() =>
    readCache(KEY.eid, DEFAULT_EID_SETTINGS),
  );
  useEffect(() => {
    return watchEidSettings((v) => {
      setData(v);
      writeCache(KEY.eid, v);
    });
  }, []);
  return data;
}

export function useRamadanSettings(): RamadanSettings {
  const [data, setData] = useState<RamadanSettings>(() =>
    readCache(KEY.ramadan, DEFAULT_RAMADAN_SETTINGS),
  );
  useEffect(() => {
    return watchRamadanSettings((v) => {
      setData(v);
      writeCache(KEY.ramadan, v);
    });
  }, []);
  return data;
}
